import React, { useState, useRef, useEffect } from "react";
import { ArrowUp, Square } from "lucide-react";

export default function Composer({ onSubmit, onCancel, isInFlight, disabled, awaitingClarification }) {
  const [text, setText] = useState("");
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = Math.min(textareaRef.current.scrollHeight, 200) + "px";
    }
  }, [text]);

  const submit = () => {
    if (!text.trim() || isInFlight || disabled) return;
    onSubmit(text.trim());
    setText("");
  };

  const onKeyDown = (e) => {
    if ((e.metaKey || e.ctrlKey) && e.key === "Enter") {
      e.preventDefault();
      submit();
    }
  };

  const placeholder = awaitingClarification
    ? "Reply or pick an option above…"
    : "Ask about incidents, risk assessments, inspections, or tasks";

  const canSend = text.trim() && !isInFlight && !disabled;

  return (
    <div className="max-w-3xl mx-auto">
      <div className="relative bg-white border border-gray-300 rounded-xl shadow-sm focus-within:border-blue-500 focus-within:ring-1 focus-within:ring-blue-500/15 transition-all">
        <textarea
          ref={textareaRef}
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
          rows={1}
          className="w-full px-4 py-3.5 pr-12 bg-transparent border-none outline-none resize-none text-[15px] text-gray-900 placeholder-gray-400 leading-relaxed"
          disabled={disabled}
        />
        <button
          onClick={isInFlight ? onCancel : submit}
          disabled={!isInFlight && !canSend}
          className={`absolute right-2.5 bottom-2.5 w-9 h-9 rounded-lg flex items-center justify-center transition-all ${
            isInFlight
              ? "bg-gray-900 text-white hover:bg-gray-800"
              : canSend
                ? "bg-blue-600 text-white hover:bg-blue-700 shadow-sm"
                : "bg-gray-100 text-gray-400"
          }`}
        >
          {isInFlight ? <Square className="w-3.5 h-3.5 fill-current" strokeWidth={0} /> : <ArrowUp className="w-4 h-4" strokeWidth={2.5} />}
        </button>
      </div>
      <div className="text-xs text-gray-400 text-center mt-2.5">
        <kbd className="px-1.5 py-0.5 bg-gray-100 rounded text-[10px] font-medium">⌘ + Enter</kbd>
        <span className="mx-1.5">to send</span>
      </div>
    </div>
  );
}
